// Adapted from @react-admin/ra-calendar@1.2.0 — see ../README.md
import type { EventInput } from '@fullcalendar/core'

/**
 * Records already carry FullCalendar's shape, so the default is the identity.
 *
 * Deviation from the original: it imported `EventInput` from
 * `@fullcalendar/core`. Type-checked from this app that combination crashes
 * TypeScript 4.5.4 outright ("Cannot read properties of undefined (reading
 * 'flags')" inside resolveESModuleSymbol) — the Enterprise build never hit it
 * because it shipped prebuilt .d.ts. `@fullcalendar/react` re-exports the same
 * type and resolves cleanly.
 */
export const convertToEvent = (event: any): EventInput => event
